import { Grid, Typography } from "@mui/material";
import { useSuperAdminUserSuscription } from "../../../../context/SuperAdmin/UserSuscriptionContext";

const SingleUserDescription = () => {
  const { user } = useSuperAdminUserSuscription();
  return (
    <Grid
      container
      sx={{
        padding: 4,
        backgroundColor: "#EEF3F6",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        width: 1,
        gap: 2,
      }}
    >
      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Nombre:
        </Typography>
        <Typography fontSize={18}>{user.nombres}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Apellidos:
        </Typography>
        <Typography fontSize={18}>{user.apellidos}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Email:
        </Typography>
        <Typography fontSize={18}>{user.email}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Fecha de creación:
        </Typography>
        <Typography fontSize={18}>{new Date(user.created_at).toLocaleString()}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Estado:
        </Typography>
        <Typography fontSize={18}>{user.estado}</Typography>
      </Grid>
    </Grid>
  );
};

export default SingleUserDescription;
